export default __webpack_public_path__ + "static/media/elo.1f8983be.png";